<script>
import SectionModel from '@/models/SectionModel'

import { mapActions } from 'vuex'
export default {
  name: 'WithMenu',
  data() {
    return {
      loading: true,
    }
  },
  async created() {
    try {
      await this.fetchMenu()
    } catch (error) {
      // console.error(JSON.stringify(error))
    } finally {
      this.loading = false
    }
  },
  computed: {
    sections() {
      return SectionModel.query()
        .with('items')
        .orderBy('order')
        .all()
    }, // sections
  },
  methods: {
    ...mapActions('shop', ['fetchMenu']),
  },
  render() {
    return this.$scopedSlots.default({
      sections: this.sections,
      loading: this.loading,
    })
  },
}
</script>
